import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WechatWorkOutlinedSvg from "@ant-design/icons-svg/es/asn/WechatWorkOutlined";
import AntdIcon from '../components/AntdIcon';
var WechatWorkOutlined = function WechatWorkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: WechatWorkOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(WechatWorkOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'WechatWorkOutlined';
}
export default RefIcon;